/**
 * Refresh if our app version has changed
 */
const getVersionFromHtml = function(html) {
  try {
    const meta = html.querySelector('meta[name="X-App-Version"]');
    return meta.getAttribute('content');
  } catch(e) {
    up.log.warn('app:getVersionFromHtml', e.message);
    return '0.0.0:0';
  }
};

const currentVersion = getVersionFromHtml(document);
console.log('app:currentVersion', currentVersion);

// reload if new build version detected
up.on('up:fragment:loaded', (event) => {
  try {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(event.response.text, 'text/html');
    const responseVersion = getVersionFromHtml(parsedHtml);
    up.log.puts('app:responseVersion', responseVersion);
    if(responseVersion !== currentVersion) {
      throw new Error('New version detected: ' + responseVersion + ' !== ' + currentVersion);
    }
  } catch(e) {
    up.log.warn('app:versionMismatch', e.message);
    up.cache.clear();
    event.preventDefault();
    return event.request.loadPage();
  }
});


/**
* Videos break in Safari when they are injected into the DOM.
* - Only binds event if Safari browser
* - `initialLoad` flag avoids our code running on initial page render
* - Query for all video elements inside fragment
* - Overwriting its `outerHTML` forces Safari to re-render the video.
*/
const isSafari = () => {
  const ua = navigator.userAgent;
  console.log(`User Agent: ${ua}`);
  return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('CriOS') && !ua.includes('FxiOS');
};

if (isSafari()) {
  let initialLoad = true;
  up.on('up:fragment:inserted', (event, fragment) => {
    if (initialLoad) {
      initialLoad = false;
      return;
    }

    const videos = fragment.querySelectorAll('video');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      video.outerHTML = video.outerHTML;
    });
  });
}
